import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetStoreStockDetailsQuery } from '../slices/storeStocksApiSlice';

const StoreStockScreen = () => {
  const { id: storeStockId } = useParams();

  const { data: storeStock, refetch, isLoading, error } = useGetStoreStockDetailsQuery(storeStockId);

  useEffect(() => {
    if (!storeStock) {
      refetch();
    }
  }, [storeStock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>StoreStock {storeStock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {storeStock?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {storeStock?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {storeStock?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {storeStock?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {storeStock?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreStock Note</h2>
              <p>{storeStock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreStock Items</h2>
              {storeStock?.storeStockItems?.length === 0 ? (
                <Message>This storeStock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {storeStock?.storeStockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>StoreStock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{storeStock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>D{storeStock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{storeStock?.status || 'N/A'}</Col>
                  <Col>{storeStock?.username || 'No user name provided'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StoreStockScreen;